module.exports = __webpack_public_path__ + "img/mb-success-icon.e2c6c52d.png";